var _defs, _circle, _path, _path2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreparingActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_968",
    width: 44.319,
    height: 44.319,
    viewBox: "0 0 44.319 44.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2,.cls-5{fill:none}.cls-2{stroke:#fff}.cls-4{stroke:none}\r\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    cx: 22.16,
    cy: 22.16,
    r: 22.16,
    fill: "#00ff6f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    d: "M5568.008-11981.249H5554v7.407",
    className: "cls-2",
    transform: "translate(-5533.351 12003.677)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    d: "M5535.308-12001.008s4.364-.336 6.721 3.217 5.171 4.686 9.607 4.753c.056-.014 2.994 0 2.994 0",
    className: "cls-2",
    transform: "translate(-5521.348 12015.076)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    className: "cls-2",
    transform: "translate(9.849 13.542)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.309,
    cy: 4.309,
    r: 4.309,
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.309,
    cy: 4.309,
    r: 3.809,
    className: "cls-5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2px",
    transform: "translate(12.311 16.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.847,
    cy: 1.847,
    r: 1.847,
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.847,
    cy: 1.847,
    r: 0.847,
    className: "cls-5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparingActive);
export default __webpack_public_path__ + "static/media/preparing-active.62cef326a7cda1e1258137b84a043abd.svg";
export { ForwardRef as ReactComponent };